// FETCH ALL STYLE_PREPARATION_SELECTED_STYLES
export const FETCH_STYLE_PREPARATION_SELECTED_STYLES_REQUEST = 'FETCH_STYLE_PREPARATION_SELECTED_STYLES_REQUEST';
export const FETCH_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS = 'FETCH_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS';
export const FETCH_STYLE_PREPARATION_SELECTED_STYLES_FAILURE = 'FETCH_STYLE_PREPARATION_SELECTED_STYLES_FAILURE';

// CREATE STYLE_PREPARATION_SELECTED_STYLES
export const CREATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST = 'CREATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST';
export const CREATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS = 'CREATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS';
export const CREATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE = 'CREATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE';

// UPDATE STYLE_PREPARATION_SELECTED_STYLES
export const UPDATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST = 'UPDATE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST';
export const UPDATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS = 'UPDATE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS';
export const UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE = 'UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE';

// FETCH SINGLE STATE OF STYLE_PREPARATION_SELECTED_STYLES
export const FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST = 'FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST';
export const FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS = 'FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS';
export const FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE = 'FETCH_SINGLE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE';

// DELETE STYLE_PREPARATION_SELECTED_STYLES
export const DELETE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST = 'DELETE_STYLE_PREPARATION_SELECTED_STYLES_REQUEST';
export const DELETE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS = 'DELETE_STYLE_PREPARATION_SELECTED_STYLES_SUCCESS';
export const DELETE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE = 'DELETE_STYLE_PREPARATION_SELECTED_STYLES_FAILURE';

export const RESET_STYLE_PREPARATION_SELECTED_STYLES_INFO = 'RESET_STYLE_PREPARATION_SELECTED_STYLES_INFO';

export const CREATE_STYLE_PREPARATION_SELECTED_STYLES_FORM = 'CREATE_STYLE_PREPARATION_SELECTED_STYLES_FORM';

export const UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FORM = 'UPDATE_STYLE_PREPARATION_SELECTED_STYLES_FORM';


//FETCH INVOICE DATA
export const FETCH_STYLE_PREPARATION_INVOICE_REQUEST = 'FETCH_STYLE_PREPARATION_INVOICE_REQUEST';
export const FETCH_STYLE_PREPARATION_INVOICE_SUCCESS = 'FETCH_STYLE_PREPARATION_INVOICE_SUCCESS';
export const FETCH_STYLE_PREPARATION_INVOICE_FAILURE = 'FETCH_STYLE_PREPARATION_INVOICE_FAILURE';

export const RESET_STYLE_PREPARATION_INVOICE = 'RESET_STYLE_PREPARATION_INVOICE';

export const STYLE_PREPARATION_TAB_ACTIVATION_KEYS = 'STYLE_PREPARATION_TAB_ACTIVATION_KEYS'